module.exports = __webpack_public_path__ + "img/item3.180c31d1.png";